@if (visible()) {
  <div class="modal-overlay" (click)="close()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Ihr Zugriff ist abgelaufen</h2>
        @if (subscriptionStatus() === 'active') {
          <button class="close-btn" (click)="close()" aria-label="Schließen">&times;</button>
        }
      </div>

      <div class="modal-body">
        <p class="message">
          Um ProTyco weiter zu nutzen, benötigen Sie ein aktives Abonnement.
          Wählen Sie jetzt ein passendes Paket:
        </p>

        @if (loading()) {
          <div class="loading-spinner">Lade Preise...</div>
        } @else {
          <div class="plans-list">
            @for (plan of plans(); track plan.planKey) {
              <div class="plan-item" (click)="selectPlan(plan)">
                <div class="plan-info">
                  <h3>{{ plan.name }}</h3>
                  @if (plan.durationMonths && plan.durationMonths > 0) {
                    <p class="plan-duration">{{ plan.durationMonths }} Monat{{ plan.durationMonths > 1 ? 'e' : '' }}</p>
                  }
                </div>
                <div class="plan-pricing">
                  <span class="price">{{ plan.priceEUR | number:'1.2-2' }}€</span>
                  @if (plan.discountPercent && plan.discountPercent > 0) {
                    <span class="discount">-{{ plan.discountPercent }}%</span>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="logout()">Abmelden</button>
      </div>
    </div>
  </div>

  @if (selectedPlan()) {
    <app-checkout
      [plan]="selectedPlan()!"
      [visible]="showCheckout()"
      (closed)="closeCheckout()"
    ></app-checkout>
  }
}
